<template lang="pug">
  liondesk-dialog(
      :value="value"
      dialogTitle="Select custom number"
      okButtonText="Select custom number"
      @click:ok="redirectToCustomNumberModal"
      @click:cancel="cancel"
    )
      div(slot="body")
        span
        | Your plan grants you a custom number which allows you to access features that will be beneficial for you and your leads such as:
        ul.mt-3.pl-5
          li Lead Assist
          li Text 2 Sell
          li Ensure text deliverables
</template>

<script>
import LiondeskDialog from '@/Core/components/LiondeskDialog';

export default {
  components: {
    LiondeskDialog,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    cancel() {
      this.$emit('close');
    },
    redirectToCustomNumberModal() {
      window.location = `${process.env.VUE_APP_ACCOUNTS_APP_URL}/settings?modal=customNumber`;
    },
  },
}
</script>
